import React from 'react';
import useTranslate from '../../../../../customHooks/useTranslate';
import EmptyState from '../../../components/EmptyState';

/**
 * Empty state shown in the service scraping history when the hotel has no
 * previous analyses.
 */
const NoScrapingHistory = () => {
    const translate = useTranslate();

    return (
        <EmptyState
            iconName='AccessTimeOutlined'
            title={translate('no_scraping_history')}
            description={translate('no_scraping_history_description')}
        />
    );
};

export default NoScrapingHistory;
